import { Popover as PopoverComponent, Transition } from "@headlessui/react";
import {
  forwardRef,
  Fragment,
  MutableRefObject,
  PropsWithChildren,
  ReactNode,
} from "react";
import { createLocalContext } from "../../utils/create-local-context";

export const { useDeprecatedPopoverContext, DeprecatedPopoverContext } =
  createLocalContext<{ isOpen: boolean; closePopover: () => void }>()(
    "DeprecatedPopover"
  );

/**
 * TODO: look into setting up a stateless popover instead
 *
 * Headless UI has a `static` prop, but it didn't seem to work - might need to upgrade headless ui
 *
 * @deprecated use `Popover` instead
 */
interface DEPRECATED_PopoverProps {
  className?: string;
  children?: ReactNode;
}

export function DEPRECATED_Popover({
  children,
  className = "",
}: DEPRECATED_PopoverProps): JSX.Element {
  return (
    <PopoverComponent className={`relative ${className}`}>
      {({ open, close }) => (
        <DeprecatedPopoverContext.Provider
          value={{ isOpen: open, closePopover: close }}
        >
          {children}
        </DeprecatedPopoverContext.Provider>
      )}
    </PopoverComponent>
  );
}

type PopoverButtonProps = PropsWithChildren<{
  className?: string;
  "data-cy"?: string;
}>;

export const DEPRECATED_PopoverButton = forwardRef<
  HTMLButtonElement,
  PopoverButtonProps
>(({ className, children, "data-cy": dataCy }, ref) => (
  <PopoverComponent.Button ref={ref} className={className} data-cy={dataCy}>
    {children}
  </PopoverComponent.Button>
));

export const DEPRECATED_PopoverPanel = ({
  className,
  children,
}: {
  children:
    | ReactNode
    | ((renderProps: {
        open: boolean;
        close: (
          focusableElement?: HTMLElement | MutableRefObject<HTMLElement | null>
        ) => void;
      }) => JSX.Element);
  className?: string;
}) => (
  <Transition
    as={Fragment}
    enter="transition ease-out duration-200"
    enterFrom="opacity-0 translate-y-1"
    enterTo="opacity-100 translate-y-0"
    leave="transition ease-in duration-150"
    leaveFrom="opacity-100 translate-y-0"
    leaveTo="opacity-0 translate-y-1"
  >
    <PopoverComponent.Panel
      className={`absolute z-10 mt-4 bg-shale-750 rounded-lg p-5 text-white shadow-md ${className}`}
    >
      {children}
    </PopoverComponent.Panel>
  </Transition>
);
